import { TaxServiceOptions } from '../../../modules/ReferralForm/enums';
import { getAnsweredValue, MatcherAnswers } from './types';

const SMALL_BUSINESS_SERVICE_ID = 'helpWithMyBusiness';

function mapServicesToInterests(answers: MatcherAnswers): string[] {
  const services = getAnsweredValue(answers.services);
  if (!Array.isArray(services)) return [];
  const interests = services.map((serviceId) =>
    serviceId === SMALL_BUSINESS_SERVICE_ID
      ? TaxServiceOptions.small_business.value
      : TaxServiceOptions.personal_taxes.value
  );
  return [...new Set(interests)];
}

export { mapServicesToInterests };
